<script>
  import { onMount } from "svelte";
  import statStore from "./store.js";
  // import Stats from "./stats.svelte";
  import { Table } from "sveltestrap";
  import { Col, Container, Row } from "sveltestrap";

  onMount(() => {
    statStore.subscribe((currentStats) => {
      if (currentStats) {
        daily_stats = currentStats["daily"].sort(function (a, b) {
          return b[1] - a[1];
        });
        weekly_stats = currentStats["weekly"].sort(function (a, b) {
          return b[1] - a[1];
        });
        monthly_stats = currentStats["monthly"].sort(function (a, b) {
          return b[1] - a[1];
        });
      }
    });
  });

  export let name;
  let daily_stats = [];
  let weekly_stats = [];
  let monthly_stats = [];
</script>

<head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"
  />
</head>

<main>
  <h1>{name}!</h1>
  <h3>Top queries made on Vajehyab.com</h3>
  <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2203247302229892"
  crossorigin="anonymous"></script>
  <!-- horizontal -->
  <ins class="adsbygoogle"
    style="display:block"
    data-ad-client="ca-pub-2203247302229892"
    data-ad-slot="1735767239"
    data-ad-format="auto"
    data-full-width-responsive="true"></ins>
  <script>
    (adsbygoogle = window.adsbygoogle || []).push({});
  </script>
  <Container>
    <Row>
      <Col>
        <h2>Daily</h2>
        <Table bordered striped responsive>
          <thead>
            <tr>
              <th width="6rem">#</th>
              <th>Query</th>
              <th width="8rem">Count</th>
            </tr>
          </thead>
          <tbody>
            {#each daily_stats as stat, i}
              <tr>
                <th scope="row">{i + 1}</th>
                <td class="text-start">{stat["query"]}</td>
                <td>{stat["count"]}</td>
              </tr>
            {/each}
          </tbody>
        </Table>
      </Col>

      <Col>
        <h2>Weekly</h2>
        <Table bordered striped>
          <thead>
            <tr>
              <th width="6rem">#</th>
              <th>Query</th>
              <th width="8rem">Count</th>
            </tr>
          </thead>
          <tbody>
            {#each weekly_stats as stat, i}
              <tr>
                <th scope="row">{i + 1}</th>
                <td class="text-start">{stat["query"]}</td>
                <td>{stat["count"]}</td>
              </tr>
            {/each}
          </tbody>
        </Table>
      </Col>
      <Col>
        <h2>Monthly</h2>
        <Table bordered striped>
          <thead>
            <tr>
              <th width="6rem">#</th>
              <th>Query</th>
              <th width="8rem">Count</th>
            </tr>
          </thead>
          <tbody>
            {#each monthly_stats as stat, i}
              <tr>
                <th scope="row">{i + 1}</th>
                <td class="text-start">{stat["query"]}</td>
                <td>{stat["count"]}</td>
              </tr>
            {/each}
          </tbody>
        </Table>
      </Col>
    </Row>
  </Container>
</main>

<style>
  main {
    text-align: center;
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }

  h1 {
    color: #ff3e00;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
